<template>
  <div v-if="isPC" class="photo-page">
    <div class="banner">
      <img
        v-if="locale === 'zh'"
        src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/photo/banner-1.png"
      />
      <img
        v-else
        src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/photo/banner-1_en.png"
      />
    </div>
    <div class="banner">
      <img
        src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/photo/banner-4.png"
      />
      <div class="posi-wrap posi-right">
        <p class="product-name">
          <span class="new-tag"
            >{{ $t("product_13")
            }}<span class="new-tag-text">{{ $t("slogan_4") }}</span></span
          >
        </p>
        <p class="product-desc">{{ $t("photo.text_11") }}</p>
        <p class="product-desc">{{ $t("photo.text_12") }}</p>
        <div v-if="locale === 'zh'" class="posi-btn-wrap">
          <span @click="goOutside('https://item.jd.com/100161035463.html')"
            >整机购买></span
          >
          <span @click="goOutside('https://item.jd.com/100205890796.html')"
            >耗材购买></span
          >
        </div>
      </div>
    </div>
    <div class="banner">
      <img
        src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/photo/banner-2.png"
      />
      <div class="posi-wrap posi-left">
        <p class="product-name">{{ $t("product_4") }}</p>
        <p class="product-desc">
          {{ $t("photo.slogan") }}
        </p>
        <p class="product-desc">
          {{ $t("photo.spec_1") }}
        </p>
        <div v-if="locale === 'zh'" class="posi-btn-wrap">
          <span
            @click="
              goOutside(
                'https://detail.tmall.com/item.htm?spm=a220o.1000855.w20791705-22340162019.6.18c756abisz9Mj&id=608536442595&scene=taobao_shop'
              )
            "
            >整机购买></span
          >
          <span
            @click="
              goOutside(
                'https://detail.tmall.com/item.htm?spm=a220o.1000855.w5001-22892103100.5.654a6fdcp3Allh&id=610206831756&rn=cc24b8f85aecaf13a9c0848c3c686323&abbucket=12&scene=taobao_shop'
              )
            "
            >耗材购买></span
          >
        </div>
      </div>
    </div>
    <div class="banner">
      <img
        src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/photo/banner-3.png"
      />
      <div class="posi-wrap posi-right">
        <p class="product-name">{{ $t("product_5") }}</p>
        <p class="product-desc">{{ $t("photo.spec_2") }}</p>
        <p class="product-desc">{{ $t("photo.spec_3") }}</p>
        <div v-if="locale === 'zh'" class="posi-btn-wrap">
          <span
            @click="
              goOutside(
                'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-22892103130.64.54635a3aWSXaqa&id=682714914255&rn=acc7c4298f72bedc0a01a822c24c90c3&abbucket=1'
              )
            "
            >整机购买></span
          >
          <span
            @click="
              goOutside(
                'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-22892103130.76.711a5a3ap2trXo&id=683358672232&rn=a1a34596c2c2758c14fc447b191cd94c&abbucket=1&skuId=4886531448569'
              )
            "
            >耗材购买></span
          >
        </div>
      </div>
    </div>
  </div>
  <div v-else class="photo-mobile">
    <div class="banner">
      <img
        v-if="locale === 'zh'"
        src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/photo/banner_mobile_1.png"
      />
      <img
        v-else
        src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/photo/banner_mobile_1_en.png"
      />
    </div>
    <div class="banner">
      <img
        src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/photo/banner_mobile_4.png"
      />
      <div class="info-wrap">
        <p class="title">{{ $t("product_13") }}</p>
        <p class="desc">
          {{ $t("photo.text_11") }}
        </p>
        <p class="desc">{{ $t("photo.text_12") }}</p>
        <div v-if="locale === 'zh'" class="btns-wrap">
          <div
            class="btn"
            @click="goOutside('https://item.jd.com/100161035463.html')"
          >
            整机购买 >
          </div>
          <div
            class="btn"
            @click="goOutside('https://item.jd.com/100205890796.html')"
          >
            耗材购买 >
          </div>
        </div>
      </div>
    </div>
    <div class="banner">
      <img
        src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/photo/banner_mobile_2.png"
      />
      <div class="info-wrap">
        <p class="title">{{ $t("product_4") }}</p>
        <p class="desc">
          {{ $t("photo.slogan") }}
        </p>
        <p class="desc">{{ $t("photo.spec_1") }}</p>
        <div v-if="locale === 'zh'" class="btns-wrap">
          <div
            class="btn"
            @click="
              goOutside(
                'https://detail.tmall.com/item.htm?spm=a220o.1000855.w20791705-22340162019.6.18c756abisz9Mj&id=608536442595&scene=taobao_shop'
              )
            "
          >
            整机购买 >
          </div>
          <div
            class="btn"
            @click="
              goOutside(
                'https://detail.tmall.com/item.htm?spm=a220o.1000855.w5001-22892103100.5.654a6fdcp3Allh&id=610206831756&rn=cc24b8f85aecaf13a9c0848c3c686323&abbucket=12&scene=taobao_shop'
              )
            "
          >
            耗材购买 >
          </div>
        </div>
      </div>
    </div>
    <div class="banner">
      <img
        src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/photo/banner_mobile_3.png"
      />
      <div class="info-wrap">
        <p class="title">{{ $t("product_5") }}</p>
        <p class="desc">{{ $t("photo.spec_2") }}</p>
        <p class="desc">{{ $t("photo.spec_3") }}</p>
        <div v-if="locale === 'zh'" class="btns-wrap">
          <div
            class="btn"
            @click="
              goOutside(
                'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-22892103130.64.54635a3aWSXaqa&id=682714914255&rn=acc7c4298f72bedc0a01a822c24c90c3&abbucket=1'
              )
            "
          >
            整机购买 >
          </div>
          <div
            class="btn"
            @click="
              goOutside(
                'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-22892103130.76.711a5a3ap2trXo&id=683358672232&rn=a1a34596c2c2758c14fc447b191cd94c&abbucket=1&skuId=4886531448569'
              )
            "
          >
            耗材购买 >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      locale: localStorage.getItem("locale") || "zh",
      isPC: document.body.clientWidth > 768,
    };
  },
  created() {
    window.onresize = () => {
      this.isPC = document.body.clientWidth > 768;
    };
  },
  methods: {
    goOutside(path) {
      window.open(path);
    },
  },
};
</script>
<style lang="less" scoped>
.photo-page {
  padding-bottom: 20px;
  .banner {
    aspect-ratio: 1920/720;
    position: relative;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 100%;
      display: block;
    }
    .posi-wrap {
      position: absolute;
      top: 33.333%;
      &.posi-left {
        left: 20%;
      }
      &.posi-right {
        left: 53.802%;
      }
      .product-name {
        font-size: 2.2917vw;
        font-weight: 500;
        line-height: 1;
        color: var(--jy-color-gray);
        margin-bottom: 3.889%;
      }
      .new-tag {
        position: relative;
      }
      .new-tag-text {
        height: 20px;
        padding: 0 15px;
        position: absolute;
        top: -24px;
        right: -90px;
        font-size: 14px;
        line-height: 20px;
        color: #ffffff;
        border-radius: 4px;
        background-color: #ee6625;
      }
      .new-tag-text::after {
        content: "";
        position: absolute;
        top: 11px;
        left: 0;
        width: 0;
        height: 0;
        transform: rotate(-90deg);
        border: 8px solid;
        border-color: #ee6625 transparent transparent transparent;
      }
      .product-desc {
        max-width: 33vw;
        font-size: 1.0417vw;
        font-weight: 400;
        line-height: 1.44;
        color: var(--jy-color-gray);
        margin-bottom: 2%;
      }
      .posi-btn-wrap {
        display: flex;
        align-items: center;
        margin-top: 9.722%;
        span {
          width: 6.6667vw;
          height: 2.0833vw;
          text-align: center;
          line-height: 2.0833vw;
          font-size: 0.8333vw;
          color: #f5f5f5;
          cursor: pointer;
          border-radius: 2.0833vw;
          background-color: #252c36;
          &:first-child {
            margin-right: 40px;
          }
          &:hover {
            background-color: #313a47;
          }
          &:active {
            opacity: 0.6;
          }
          &.disabled {
            opacity: 0.3 !important;
            cursor: not-allowed !important;
          }
        }
      }
    }
  }
}
.photo-mobile {
  .banner {
    position: relative;
    margin-bottom: 8px;
    aspect-ratio: 750/971;
    img {
      width: 100%;
      display: block;
    }
    .info-wrap {
      width: 100%;
      position: absolute;
      top: 48px;
      left: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      p {
        padding: 0 20px;
        text-align: center;
        &.title {
          font-size: 23px;
          font-weight: 500;
          color: #191919;
          margin-bottom: 16px;
        }
        &.desc {
          font-size: 12px;
          color: #191919;
          font-weight: 400;
        }
      }
      .btns-wrap {
        display: flex;
        margin-top: 40px;
        .btn {
          width: 87px;
          height: 28px;
          font-size: 12px;
          font-weight: 300;
          text-align: center;
          line-height: 28px;
          color: #f5f5f5;
          border-radius: 14px;
          background-color: #191919;
          &:first-child {
            margin-right: 30px;
          }
          &:active {
            opacity: 0.6;
          }
        }
      }
    }
  }
}
</style>
